import React from 'react';

/**
 * HA-445: shown while the page reads the session (GET /auth/session) before the app renders. A cold
 * API takes several seconds to answer; a blank page that long looks broken. Plain markup and inline
 * styles: it renders before the theme and the router exist.
 */
const SessionBootSplash: React.FC = () => (
  <div
    role="status"
    aria-live="polite"
    data-testid="session-boot-splash"
    style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      color: '#0b3d63',
      background: '#f5f7fa',
    }}
  >
    Loading HealioSpace…
  </div>
);

export default SessionBootSplash;
